import { render } from "./activationList.vue?vue&type=template&id=0edd6e50&scoped=true"
import script from "./activationList.vue?vue&type=script&lang=js"
export * from "./activationList.vue?vue&type=script&lang=js"

import "./activationList.vue?vue&type=style&index=0&id=0edd6e50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0edd6e50"

export default script